import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const baseStyle = defineStyle({
  p: "8px 12px",
  color: "#ffffff",
  rounded: "2px",
});

// export the component theme
export const tooltipTheme = defineStyleConfig({
  baseStyle,
});
